import {
  CarouselVisiblePayload,
  ClickCarouselLinkPayload,
} from '@noths/polaris-client-ribbons-design-system';
import { createAction } from '@reduxjs/toolkit';

export const carouselVisible = createAction<CarouselVisiblePayload>('linkCarousel/carouselVisible');

export const carouselLinkClick = createAction<ClickCarouselLinkPayload>(
  'linkCarousel/carouselLinkClick',
);
